'use client';
var classes = { "root": "m_b37d9ac7", "notification": "m_5ed0edd0" };

export { classes as default };
//# sourceMappingURL=Notifications.module.css.mjs.map